import React from 'react';
import './Blogs.css';
import { Button, Card, Col, Container, Image, Row } from 'react-bootstrap';
import blogData from '../../FakeData/ProjectData/BlogsData/BlogsData';
import Pulse from 'react-reveal/Pulse';

const Blogs = () => {
  return (
    <>
      <Container id="blogsPage" className="text-center">
        <h1 className="my-3 text-center sectionTitle">Blogs</h1>
        <Row className="d-flex justify-content-center text-dark customSection">
          {
            blogData.map(item =>

              <Col md={6} className="m-3 custom-blog" key={item.id}>
                <Pulse duration={4000} delay={3000}>
                  <Card>
                    <Row className="m-3 p-3 innerBlog">
                      <Col md={6} xs={12} sm={4}>
                        <Image
                          height="100%"
                          width="100%"
                          src={item.image}
                          alt="">
                        </Image>
                      </Col>
                      <Col
                        md={6}
                        xs={12}
                        sm={8}>
                        <h3 className="blogName">
                          {item.name}
                        </h3>
                        <p>
                          {item.description}
                        </p>
                      </Col>
                    </Row>
                    <a
                      href={item.blogLink}
                      target="_blank"
                      rel="noreferrer">
                      <div className="middle">
                        <div className="m-3 middle-btn">
                          Read Full Blog
                          </div>
                      </div>
                    </a>
                  </Card>
                </Pulse>
              </Col>
            )
          }
        </Row>
        <a href="https://medium.com/@reya3183"
          target="_blank"
          rel="noreferrer">
          <Button variant="outline-light">
            Explore More Blogs
        </Button>
        </a>
      </Container>

    </>
  );
};

export default Blogs;